var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-faq"},[_c('div',{staticClass:"v-faq__container"},[_c('div',{staticClass:"c-body-text"},[_c('c-content-block',{attrs:{"slug":"faq"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }